<template>
  <div>
    <table class="table table-striped" id="sampleTable">
      <thead>
        <tr>
          <th scope="col">Nombre</th>
          <th scope="col">Perfil</th>
          <th scope="col">Fecha de Registro</th>
          <th scope="col">Fecha de Actualización</th>
        </tr>
      </thead>
      <tbody>
        <tr v-for="usuario in usuarios" :key="usuario.idUsuario">
          <td>{{ usuario.nombre }}</td>
          <td>{{ usuario.perfilNombre }}</td>
          <td>{{ getFormattedDate(usuario.fechaReg, "DD/MM/YYYY") }}</td>
          <td>{{ getFormattedDate(usuario.fechaAct, "DD/MM/YYYY") }}</td>
        </tr>
      </tbody>
    </table>
  </div>
</template>
<script>
import api from "@/services/api";
import dateFormat from "@/modules/dateFormat.js";

import * as $ from "jquery";
window["$"] = $;
window["jQuery"] = $;
export default {
  props: {
    p_idPersona: {
      type: String,
      required: true,
    },
    p_email: {
      type: String,
      required: true,
    },
  },
  data() {
    return {
      usuarios: [],
      datoUsuario: {},
      nombreBusqueda: "",
      titulo: "",
      btnCrear: false,
      btnEditar: false,
      modalWindow: true,
      perfils: [],
      suscripcions: [],
      mostrarBloque: false,
      crearUsuarios: null,
      showModalHelp: false,
    };
  },
  mounted() {
    this.getData(this.paginaActual);
  },
  methods: {
    getFormattedDate(date) {
      return dateFormat.getFormattedDate(date);
    },
    mostrarOcultarBloque() {
      this.mostrarBloque = !this.mostrarBloque;
    },
    getData() {
      api.get("/vwusuarios/idempresa-idpersona/" +
            window.sessionStorage.getItem("idEmpresa") +
            "/" +
            this.p_idPersona
        )
        .then((response) => {
          this.usuarios = response.data;
        });
    },
  },
};
</script>
